define('view/finder/unit.finder.view',['require','exports','module','./base.finder.view','model/unit.model'],function(require, exports, module) {
  //prettier-ignore
  var BaseFinderView = require('./base.finder.view'),
      UnitModel      = require('model/unit.model');

  var UnitFinderView = BaseFinderView.extend({
    options: function() {
      return {
        searchCollectionClass: UnitModel.Collection,
        searchFields: [
          {
            name: 'name',
            displayName: 'Name',
            searchableCollectionClass: UnitModel.Collection,
            searchableName: 'name',
            useDistinctAutocompleteValues: true,
          },
        ],
        filters: [
          {
            field: 'active',
            value: true,
            hidden: true,
          },
        ],
      };
    },

    internalViewOptions: BaseFinderView.extendInternalViewOptions({
      searchTableView: function() {
        return {
          columns: [{ text: 'Name', data: 'name' }],
        };
      },
      selectedTableView: function() {
        return {
          columns: [{ text: 'Name', data: 'name' }],
        };
      },
    }),
  });

  module.exports = UnitFinderView;
});

